import React from 'react';
import { IAsyncRoute } from 'us.collection/interfaces';

export const Containers:Array<IAsyncRoute> = [
    {Container:React.lazy(()=>import('../containers/PartPayments')),Route:'part-payments'},
];
